/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AgendaRouteImport } from './routes/agenda'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as GaleriaRouteImport } from './routes/galeria'
import { Route as MateriaisRouteImport } from './routes/materiais'
import { Route as NoticiasRouteImport } from './routes/noticias'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as PropostasRouteImport } from './routes/propostas'
import { Route as QuemERouteImport } from './routes/quem-e'
import { Route as TrabalhosRouteImport } from './routes/trabalhos'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAgendaRouteImport } from './routes/admin.agenda'
import { Route as AdminCategoriasRouteImport } from './routes/admin.categorias'
import { Route as AdminConfiguracoesRouteImport } from './routes/admin.configuracoes'
import { Route as AdminDepoimentosRouteImport } from './routes/admin.depoimentos'
import { Route as AdminGaleriasRouteImport } from './routes/admin.galerias'
import { Route as AdminMateriaisRouteImport } from './routes/admin.materiais'
import { Route as AdminMensagensRouteImport } from './routes/admin.mensagens'
import { Route as AdminNoticiasRouteImport } from './routes/admin.noticias'
import { Route as AdminNumerosRouteImport } from './routes/admin.numeros'
import { Route as AdminPaginasRouteImport } from './routes/admin.paginas'
import { Route as AdminPropostasRouteImport } from './routes/admin.propostas'
import { Route as AdminTrabalhosRouteImport } from './routes/admin.trabalhos'
import { Route as AdminTrajetoriaRouteImport } from './routes/admin.trajetoria'
import { Route as AdminVideosRouteImport } from './routes/admin.videos'
import { Route as GaleriaSlugRouteImport } from './routes/galeria.$slug'
import { Route as NoticiasSlugRouteImport } from './routes/noticias.$slug'
import { Route as PropostasSlugRouteImport } from './routes/propostas.$slug'
import { Route as TrabalhosSlugRouteImport } from './routes/trabalhos.$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaRoute = AgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ContatoRoute = ContatoRouteImport.update({
  id: '/contato',
  path: '/contato',
  getParentRoute: () => rootRouteImport,
} as any)
const GaleriaRoute = GaleriaRouteImport.update({
  id: '/galeria',
  path: '/galeria',
  getParentRoute: () => rootRouteImport,
} as any)
const MateriaisRoute = MateriaisRouteImport.update({
  id: '/materiais',
  path: '/materiais',
  getParentRoute: () => rootRouteImport,
} as any)
const NoticiasRoute = NoticiasRouteImport.update({
  id: '/noticias',
  path: '/noticias',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const PropostasRoute = PropostasRouteImport.update({
  id: '/propostas',
  path: '/propostas',
  getParentRoute: () => rootRouteImport,
} as any)
const QuemERoute = QuemERouteImport.update({
  id: '/quem-e',
  path: '/quem-e',
  getParentRoute: () => rootRouteImport,
} as any)
const TrabalhosRoute = TrabalhosRouteImport.update({
  id: '/trabalhos',
  path: '/trabalhos',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosRoute = VideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAgendaRoute = AdminAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCategoriasRoute = AdminCategoriasRouteImport.update({
  id: '/categorias',
  path: '/categorias',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfiguracoesRoute = AdminConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDepoimentosRoute = AdminDepoimentosRouteImport.update({
  id: '/depoimentos',
  path: '/depoimentos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGaleriasRoute = AdminGaleriasRouteImport.update({
  id: '/galerias',
  path: '/galerias',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMateriaisRoute = AdminMateriaisRouteImport.update({
  id: '/materiais',
  path: '/materiais',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMensagensRoute = AdminMensagensRouteImport.update({
  id: '/mensagens',
  path: '/mensagens',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNoticiasRoute = AdminNoticiasRouteImport.update({
  id: '/noticias',
  path: '/noticias',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNumerosRoute = AdminNumerosRouteImport.update({
  id: '/numeros',
  path: '/numeros',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaginasRoute = AdminPaginasRouteImport.update({
  id: '/paginas',
  path: '/paginas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPropostasRoute = AdminPropostasRouteImport.update({
  id: '/propostas',
  path: '/propostas',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrabalhosRoute = AdminTrabalhosRouteImport.update({
  id: '/trabalhos',
  path: '/trabalhos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrajetoriaRoute = AdminTrajetoriaRouteImport.update({
  id: '/trajetoria',
  path: '/trajetoria',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVideosRoute = AdminVideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => AdminRoute,
} as any)
const GaleriaSlugRoute = GaleriaSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => GaleriaRoute,
} as any)
const NoticiasSlugRoute = NoticiasSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => NoticiasRoute,
} as any)
const PropostasSlugRoute = PropostasSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => PropostasRoute,
} as any)
const TrabalhosSlugRoute = TrabalhosSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => TrabalhosRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/agenda': typeof AgendaRoute
  '/auth': typeof AuthRoute
  '/contato': typeof ContatoRoute
  '/galeria': typeof GaleriaRouteWithChildren
  '/materiais': typeof MateriaisRoute
  '/noticias': typeof NoticiasRouteWithChildren
  '/privacidade': typeof PrivacidadeRoute
  '/propostas': typeof PropostasRouteWithChildren
  '/quem-e': typeof QuemERoute
  '/trabalhos': typeof TrabalhosRouteWithChildren
  '/videos': typeof VideosRoute
  '/admin/agenda': typeof AdminAgendaRoute
  '/admin/categorias': typeof AdminCategoriasRoute
  '/admin/configuracoes': typeof AdminConfiguracoesRoute
  '/admin/depoimentos': typeof AdminDepoimentosRoute
  '/admin/galerias': typeof AdminGaleriasRoute
  '/admin/materiais': typeof AdminMateriaisRoute
  '/admin/mensagens': typeof AdminMensagensRoute
  '/admin/noticias': typeof AdminNoticiasRoute
  '/admin/numeros': typeof AdminNumerosRoute
  '/admin/paginas': typeof AdminPaginasRoute
  '/admin/propostas': typeof AdminPropostasRoute
  '/admin/trabalhos': typeof AdminTrabalhosRoute
  '/admin/trajetoria': typeof AdminTrajetoriaRoute
  '/admin/videos': typeof AdminVideosRoute
  '/galeria/$slug': typeof GaleriaSlugRoute
  '/noticias/$slug': typeof NoticiasSlugRoute
  '/propostas/$slug': typeof PropostasSlugRoute
  '/trabalhos/$slug': typeof TrabalhosSlugRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agenda': typeof AgendaRoute
  '/auth': typeof AuthRoute
  '/contato': typeof ContatoRoute
  '/galeria': typeof GaleriaRouteWithChildren
  '/materiais': typeof MateriaisRoute
  '/noticias': typeof NoticiasRouteWithChildren
  '/privacidade': typeof PrivacidadeRoute
  '/propostas': typeof PropostasRouteWithChildren
  '/quem-e': typeof QuemERoute
  '/trabalhos': typeof TrabalhosRouteWithChildren
  '/videos': typeof VideosRoute
  '/admin/agenda': typeof AdminAgendaRoute
  '/admin/categorias': typeof AdminCategoriasRoute
  '/admin/configuracoes': typeof AdminConfiguracoesRoute
  '/admin/depoimentos': typeof AdminDepoimentosRoute
  '/admin/galerias': typeof AdminGaleriasRoute
  '/admin/materiais': typeof AdminMateriaisRoute
  '/admin/mensagens': typeof AdminMensagensRoute
  '/admin/noticias': typeof AdminNoticiasRoute
  '/admin/numeros': typeof AdminNumerosRoute
  '/admin/paginas': typeof AdminPaginasRoute
  '/admin/propostas': typeof AdminPropostasRoute
  '/admin/trabalhos': typeof AdminTrabalhosRoute
  '/admin/trajetoria': typeof AdminTrajetoriaRoute
  '/admin/videos': typeof AdminVideosRoute
  '/galeria/$slug': typeof GaleriaSlugRoute
  '/noticias/$slug': typeof NoticiasSlugRoute
  '/propostas/$slug': typeof PropostasSlugRoute
  '/trabalhos/$slug': typeof TrabalhosSlugRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/agenda': typeof AgendaRoute
  '/auth': typeof AuthRoute
  '/contato': typeof ContatoRoute
  '/galeria': typeof GaleriaRouteWithChildren
  '/materiais': typeof MateriaisRoute
  '/noticias': typeof NoticiasRouteWithChildren
  '/privacidade': typeof PrivacidadeRoute
  '/propostas': typeof PropostasRouteWithChildren
  '/quem-e': typeof QuemERoute
  '/trabalhos': typeof TrabalhosRouteWithChildren
  '/videos': typeof VideosRoute
  '/admin/agenda': typeof AdminAgendaRoute
  '/admin/categorias': typeof AdminCategoriasRoute
  '/admin/configuracoes': typeof AdminConfiguracoesRoute
  '/admin/depoimentos': typeof AdminDepoimentosRoute
  '/admin/galerias': typeof AdminGaleriasRoute
  '/admin/materiais': typeof AdminMateriaisRoute
  '/admin/mensagens': typeof AdminMensagensRoute
  '/admin/noticias': typeof AdminNoticiasRoute
  '/admin/numeros': typeof AdminNumerosRoute
  '/admin/paginas': typeof AdminPaginasRoute
  '/admin/propostas': typeof AdminPropostasRoute
  '/admin/trabalhos': typeof AdminTrabalhosRoute
  '/admin/trajetoria': typeof AdminTrajetoriaRoute
  '/admin/videos': typeof AdminVideosRoute
  '/galeria/$slug': typeof GaleriaSlugRoute
  '/noticias/$slug': typeof NoticiasSlugRoute
  '/propostas/$slug': typeof PropostasSlugRoute
  '/trabalhos/$slug': typeof TrabalhosSlugRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/agenda'
    | '/auth'
    | '/contato'
    | '/galeria'
    | '/materiais'
    | '/noticias'
    | '/privacidade'
    | '/propostas'
    | '/quem-e'
    | '/trabalhos'
    | '/videos'
    | '/admin/agenda'
    | '/admin/categorias'
    | '/admin/configuracoes'
    | '/admin/depoimentos'
    | '/admin/galerias'
    | '/admin/materiais'
    | '/admin/mensagens'
    | '/admin/noticias'
    | '/admin/numeros'
    | '/admin/paginas'
    | '/admin/propostas'
    | '/admin/trabalhos'
    | '/admin/trajetoria'
    | '/admin/videos'
    | '/galeria/$slug'
    | '/noticias/$slug'
    | '/propostas/$slug'
    | '/trabalhos/$slug'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agenda'
    | '/auth'
    | '/contato'
    | '/galeria'
    | '/materiais'
    | '/noticias'
    | '/privacidade'
    | '/propostas'
    | '/quem-e'
    | '/trabalhos'
    | '/videos'
    | '/admin/agenda'
    | '/admin/categorias'
    | '/admin/configuracoes'
    | '/admin/depoimentos'
    | '/admin/galerias'
    | '/admin/materiais'
    | '/admin/mensagens'
    | '/admin/noticias'
    | '/admin/numeros'
    | '/admin/paginas'
    | '/admin/propostas'
    | '/admin/trabalhos'
    | '/admin/trajetoria'
    | '/admin/videos'
    | '/galeria/$slug'
    | '/noticias/$slug'
    | '/propostas/$slug'
    | '/trabalhos/$slug'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/agenda'
    | '/auth'
    | '/contato'
    | '/galeria'
    | '/materiais'
    | '/noticias'
    | '/privacidade'
    | '/propostas'
    | '/quem-e'
    | '/trabalhos'
    | '/videos'
    | '/admin/agenda'
    | '/admin/categorias'
    | '/admin/configuracoes'
    | '/admin/depoimentos'
    | '/admin/galerias'
    | '/admin/materiais'
    | '/admin/mensagens'
    | '/admin/noticias'
    | '/admin/numeros'
    | '/admin/paginas'
    | '/admin/propostas'
    | '/admin/trabalhos'
    | '/admin/trajetoria'
    | '/admin/videos'
    | '/galeria/$slug'
    | '/noticias/$slug'
    | '/propostas/$slug'
    | '/trabalhos/$slug'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AgendaRoute: typeof AgendaRoute
  AuthRoute: typeof AuthRoute
  ContatoRoute: typeof ContatoRoute
  GaleriaRoute: typeof GaleriaRouteWithChildren
  MateriaisRoute: typeof MateriaisRoute
  NoticiasRoute: typeof NoticiasRouteWithChildren
  PrivacidadeRoute: typeof PrivacidadeRoute
  PropostasRoute: typeof PropostasRouteWithChildren
  QuemERoute: typeof QuemERoute
  TrabalhosRoute: typeof TrabalhosRouteWithChildren
  VideosRoute: typeof VideosRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda': {
      id: '/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contato': {
      id: '/contato'
      path: '/contato'
      fullPath: '/contato'
      preLoaderRoute: typeof ContatoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/galeria': {
      id: '/galeria'
      path: '/galeria'
      fullPath: '/galeria'
      preLoaderRoute: typeof GaleriaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materiais': {
      id: '/materiais'
      path: '/materiais'
      fullPath: '/materiais'
      preLoaderRoute: typeof MateriaisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/noticias': {
      id: '/noticias'
      path: '/noticias'
      fullPath: '/noticias'
      preLoaderRoute: typeof NoticiasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/propostas': {
      id: '/propostas'
      path: '/propostas'
      fullPath: '/propostas'
      preLoaderRoute: typeof PropostasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quem-e': {
      id: '/quem-e'
      path: '/quem-e'
      fullPath: '/quem-e'
      preLoaderRoute: typeof QuemERouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trabalhos': {
      id: '/trabalhos'
      path: '/trabalhos'
      fullPath: '/trabalhos'
      preLoaderRoute: typeof TrabalhosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos': {
      id: '/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof VideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/agenda': {
      id: '/admin/agenda'
      path: '/agenda'
      fullPath: '/admin/agenda'
      preLoaderRoute: typeof AdminAgendaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/categorias': {
      id: '/admin/categorias'
      path: '/categorias'
      fullPath: '/admin/categorias'
      preLoaderRoute: typeof AdminCategoriasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/configuracoes': {
      id: '/admin/configuracoes'
      path: '/configuracoes'
      fullPath: '/admin/configuracoes'
      preLoaderRoute: typeof AdminConfiguracoesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/depoimentos': {
      id: '/admin/depoimentos'
      path: '/depoimentos'
      fullPath: '/admin/depoimentos'
      preLoaderRoute: typeof AdminDepoimentosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/galerias': {
      id: '/admin/galerias'
      path: '/galerias'
      fullPath: '/admin/galerias'
      preLoaderRoute: typeof AdminGaleriasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/materiais': {
      id: '/admin/materiais'
      path: '/materiais'
      fullPath: '/admin/materiais'
      preLoaderRoute: typeof AdminMateriaisRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mensagens': {
      id: '/admin/mensagens'
      path: '/mensagens'
      fullPath: '/admin/mensagens'
      preLoaderRoute: typeof AdminMensagensRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/noticias': {
      id: '/admin/noticias'
      path: '/noticias'
      fullPath: '/admin/noticias'
      preLoaderRoute: typeof AdminNoticiasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/numeros': {
      id: '/admin/numeros'
      path: '/numeros'
      fullPath: '/admin/numeros'
      preLoaderRoute: typeof AdminNumerosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/paginas': {
      id: '/admin/paginas'
      path: '/paginas'
      fullPath: '/admin/paginas'
      preLoaderRoute: typeof AdminPaginasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/propostas': {
      id: '/admin/propostas'
      path: '/propostas'
      fullPath: '/admin/propostas'
      preLoaderRoute: typeof AdminPropostasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/trabalhos': {
      id: '/admin/trabalhos'
      path: '/trabalhos'
      fullPath: '/admin/trabalhos'
      preLoaderRoute: typeof AdminTrabalhosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/trajetoria': {
      id: '/admin/trajetoria'
      path: '/trajetoria'
      fullPath: '/admin/trajetoria'
      preLoaderRoute: typeof AdminTrajetoriaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/videos': {
      id: '/admin/videos'
      path: '/videos'
      fullPath: '/admin/videos'
      preLoaderRoute: typeof AdminVideosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/galeria/$slug': {
      id: '/galeria/$slug'
      path: '/$slug'
      fullPath: '/galeria/$slug'
      preLoaderRoute: typeof GaleriaSlugRouteImport
      parentRoute: typeof GaleriaRoute
    }
    '/noticias/$slug': {
      id: '/noticias/$slug'
      path: '/$slug'
      fullPath: '/noticias/$slug'
      preLoaderRoute: typeof NoticiasSlugRouteImport
      parentRoute: typeof NoticiasRoute
    }
    '/propostas/$slug': {
      id: '/propostas/$slug'
      path: '/$slug'
      fullPath: '/propostas/$slug'
      preLoaderRoute: typeof PropostasSlugRouteImport
      parentRoute: typeof PropostasRoute
    }
    '/trabalhos/$slug': {
      id: '/trabalhos/$slug'
      path: '/$slug'
      fullPath: '/trabalhos/$slug'
      preLoaderRoute: typeof TrabalhosSlugRouteImport
      parentRoute: typeof TrabalhosRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAgendaRoute: typeof AdminAgendaRoute
  AdminCategoriasRoute: typeof AdminCategoriasRoute
  AdminConfiguracoesRoute: typeof AdminConfiguracoesRoute
  AdminDepoimentosRoute: typeof AdminDepoimentosRoute
  AdminGaleriasRoute: typeof AdminGaleriasRoute
  AdminMateriaisRoute: typeof AdminMateriaisRoute
  AdminMensagensRoute: typeof AdminMensagensRoute
  AdminNoticiasRoute: typeof AdminNoticiasRoute
  AdminNumerosRoute: typeof AdminNumerosRoute
  AdminPaginasRoute: typeof AdminPaginasRoute
  AdminPropostasRoute: typeof AdminPropostasRoute
  AdminTrabalhosRoute: typeof AdminTrabalhosRoute
  AdminTrajetoriaRoute: typeof AdminTrajetoriaRoute
  AdminVideosRoute: typeof AdminVideosRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAgendaRoute: AdminAgendaRoute,
  AdminCategoriasRoute: AdminCategoriasRoute,
  AdminConfiguracoesRoute: AdminConfiguracoesRoute,
  AdminDepoimentosRoute: AdminDepoimentosRoute,
  AdminGaleriasRoute: AdminGaleriasRoute,
  AdminMateriaisRoute: AdminMateriaisRoute,
  AdminMensagensRoute: AdminMensagensRoute,
  AdminNoticiasRoute: AdminNoticiasRoute,
  AdminNumerosRoute: AdminNumerosRoute,
  AdminPaginasRoute: AdminPaginasRoute,
  AdminPropostasRoute: AdminPropostasRoute,
  AdminTrabalhosRoute: AdminTrabalhosRoute,
  AdminTrajetoriaRoute: AdminTrajetoriaRoute,
  AdminVideosRoute: AdminVideosRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface GaleriaRouteChildren {
  GaleriaSlugRoute: typeof GaleriaSlugRoute
}

const GaleriaRouteChildren: GaleriaRouteChildren = {
  GaleriaSlugRoute: GaleriaSlugRoute,
}

const GaleriaRouteWithChildren =
  GaleriaRoute._addFileChildren(GaleriaRouteChildren)

interface NoticiasRouteChildren {
  NoticiasSlugRoute: typeof NoticiasSlugRoute
}

const NoticiasRouteChildren: NoticiasRouteChildren = {
  NoticiasSlugRoute: NoticiasSlugRoute,
}

const NoticiasRouteWithChildren = NoticiasRoute._addFileChildren(
  NoticiasRouteChildren,
)

interface PropostasRouteChildren {
  PropostasSlugRoute: typeof PropostasSlugRoute
}

const PropostasRouteChildren: PropostasRouteChildren = {
  PropostasSlugRoute: PropostasSlugRoute,
}

const PropostasRouteWithChildren = PropostasRoute._addFileChildren(
  PropostasRouteChildren,
)

interface TrabalhosRouteChildren {
  TrabalhosSlugRoute: typeof TrabalhosSlugRoute
}

const TrabalhosRouteChildren: TrabalhosRouteChildren = {
  TrabalhosSlugRoute: TrabalhosSlugRoute,
}

const TrabalhosRouteWithChildren = TrabalhosRoute._addFileChildren(
  TrabalhosRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AgendaRoute: AgendaRoute,
  AuthRoute: AuthRoute,
  ContatoRoute: ContatoRoute,
  GaleriaRoute: GaleriaRouteWithChildren,
  MateriaisRoute: MateriaisRoute,
  NoticiasRoute: NoticiasRouteWithChildren,
  PrivacidadeRoute: PrivacidadeRoute,
  PropostasRoute: PropostasRouteWithChildren,
  QuemERoute: QuemERoute,
  TrabalhosRoute: TrabalhosRouteWithChildren,
  VideosRoute: VideosRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
